import { useThemeStore } from "@stores/theme.store";
import { Button, Select } from "antd";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { FcFinePrint } from "react-icons/fc";
import { Spiner } from "@components/loaders/spiner";
import { StudentTahfidz } from "@services/dtos/school.dto";
import { FilterOutlined } from "@ant-design/icons";
import { PopupCustom } from "@components/general/popup";
import { FilterButton } from "@components/general/filter_button";
moment.locale("id");

export const TahfidzDataPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_TAHFIDZ, nis, limit],
    queryFn: () => SchoolService.studentTahfidz({ nis, limit }),
  });

  const onOpenDetail = (tahfidz: StudentTahfidz) => {
    navigate(linkPage.TAHFIDZ_DETAIL_PAGE, { state: tahfidz });
  };

  useEffect(() => {
    setAppBar({ title: "Tahfidz", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Tahfidz",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <>
          {/* set filter */}
          <FilterButton
            limit={limit}
            text="data terakhir"
            onFilterClick={() => setPopupFilter(true)}
          />
          {/* end of set filter */}

          {/* report */}
          <div className="tw-mt-8">
            {isPending ? (
              <div className="tw-text-center card-body">
                <Spiner />
              </div>
            ) : data?.data != null && data.data.length > 0 ? (
              <>
                {data.data.map((item, idx) => (
                  <div
                    key={idx}
                    className="tw-mb-4 tw-py-2 card-body"
                    onClick={() => onOpenDetail(item)}
                  >
                    <div className="tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-xs tw-font-medium ">
                        {moment(item.tanggal ?? Date.now()).format(
                          "DD MMMM YYYY"
                        )}
                      </div>
                    </div>
                    <div
                      className="tw-pb-2 tw-mb-2 tw-flex tw-justify-between tw-items-end tw-font-semibold tw-border-primary"
                      style={{ borderBottom: "1px solid" }}
                    >
                      <div className="tw-text-sm">
                        {item.hafalanBaru} Halaman
                      </div>
                    </div>

                    <div className="tw-text-xs tw-text-end tw-text-text-tertiary tw-italic">
                      klik untuk melihat detail
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="tw-p-8 tw-text-center card-body">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            )}
          </div>
          {/* end of report */}
        </>
      </div>

      <PopupCustom
        title="Filter Data"
        open={popupFilter}
        onCancel={() => setPopupFilter(false)}
        slideUpModal={true}
      >
        <div className="">
          <Select
            className=" tw-text-base"
            placeholder="Pilih Jumlah Ditampilkan"
            defaultValue={limit}
            style={{ width: "100%" }}
            allowClear
            onChange={(e) => setLimit(e)}
            options={[
              { value: "5", label: "5 data terakhir" },
              { value: "10", label: "10 data terakhir" },
              { value: "25", label: "25 data terakhir" },
            ]}
          ></Select>
          <Button
            onClick={() => setPopupFilter(false)}
            className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-base tw-rounded-xl tw-bg-red-500 tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
          >
            Tutup
          </Button>
        </div>
      </PopupCustom>
    </>
  );
};
